{
  "familyId": "STU-INTERNET",
  "questions": [
    {
      "id": "STU-INTERNET-001",
      "familyId": "STU-INTERNET",
      "module": "Studievaardig",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "informatie",
      "subSkill": "info_internet",
      "questionType": "multiple_choice",
      "question": "Je zoekt informatie over de Waddeneilanden voor een werkstuk. Welke zoekterm geeft waarschijnlijk de beste resultaten?",
      "options": ["Waddeneilanden natuur en ligging", "eilanden in het algemeen", "water in Nederland zoeken", "vakantie strand op een eiland"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Goede zoektermen kiezen",
            "content": "Gebruik specifieke woorden die precies beschrijven wat je zoekt. Combineer het onderwerp met het deelonderwerp. Te brede termen geven te veel resultaten, te smalle termen te weinig.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "internet_zoekterm",
      "variantIndex": 1,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.77,
      "pedagogy": {
        "dok": 2
      },
      "feedback": {
        "explanationText": "'Waddeneilanden natuur en ligging' is specifiek genoeg om goede resultaten te krijgen. Het combineert het onderwerp (Waddeneilanden) met wat je wilt weten (natuur en ligging).",
        "solutionSteps": [
          "Bedenk wat je precies wilt weten",
          "Combineer het onderwerp met het deelonderwerp",
          "'Waddeneilanden natuur en ligging' is specifiek en gericht"
        ],
        "distractorExplanations": {
          "0": "Goed! Deze zoekterm is specifiek en combineert onderwerp met deelonderwerp.",
          "1": "'Eilanden in het algemeen' is veel te breed — je krijgt resultaten over alle eilanden ter wereld.",
          "2": "'Water in Nederland zoeken' gaat over water in het algemeen, niet specifiek over de Waddeneilanden.",
          "3": "'Vakantie strand op een eiland' gaat over vakantie, niet over informatie voor een werkstuk."
        }
      }
    },
    {
      "id": "STU-INTERNET-002",
      "familyId": "STU-INTERNET",
      "module": "Studievaardig",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "informatie",
      "subSkill": "info_internet",
      "questionType": "multiple_choice",
      "question": "Je vindt een website over dinosaurussen. Hoe controleer je of de informatie betrouwbaar is?",
      "options": ["Kijk wie de website heeft gemaakt en of er bronnen worden genoemd", "Als het er mooi uitziet, klopt het wel", "De eerste website in Google is altijd de beste", "Als er veel plaatjes op staan, is het betrouwbaar"],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "rule",
          "data": {
            "title": "Betrouwbaarheid checken",
            "content": "Stel jezelf 4 vragen: 1) Wie schreef het? 2) Staan er bronnen? 3) Is het recent? 4) Klopt het met andere sites?",
            "icon": "lightbulb"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Betrouwbaarheid checken",
            "content": "Check altijd: 1) Wie heeft het geschreven? (expert, organisatie?) 2) Worden er bronnen genoemd? 3) Is de informatie recent? 4) Staat dezelfde informatie op andere betrouwbare sites?",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "internet_betrouwbaarheid",
      "variantIndex": 2,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.75,
      "pedagogy": {
        "dok": 2
      },
      "feedback": {
        "explanationText": "Een betrouwbare website vermeldt wie de maker is (een expert of organisatie) en noemt bronnen. Uiterlijk, positie in Google of aantal plaatjes zeggen niets over betrouwbaarheid. Controleer altijd: wie schreef het, en worden er bronnen genoemd?",
        "solutionSteps": [
          "Check de maker: wie heeft het geschreven?",
          "Check de bronnen: worden er verwijzingen gegeven?",
          "Uiterlijk en Google-positie zeggen niets over betrouwbaarheid"
        ],
        "distractorExplanations": {
          "0": "Goed! Maker en bronnen zijn de belangrijkste indicatoren van betrouwbaarheid.",
          "1": "Je dacht waarschijnlijk dat een mooie website ook betrouwbaar is. Maar uiterlijk zegt niets over de inhoud. Onthoud: ook onbetrouwbare websites kunnen er mooi uitzien.",
          "2": "Je dacht waarschijnlijk dat Google de betrouwbaarste website bovenaan zet. Maar Google rangschikt op populariteit en relevantie, niet op betrouwbaarheid. Onthoud: advertenties staan zelfs bovenaan.",
          "3": "Je dacht waarschijnlijk dat veel plaatjes een teken van betrouwbaarheid is. Maar plaatjes maken een website aantrekkelijk, niet betrouwbaar. Onthoud: check altijd de maker en de bronnen."
        }
      }
    },
    {
      "id": "STU-INTERNET-003",
      "familyId": "STU-INTERNET",
      "module": "Studievaardig",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "informatie",
      "subSkill": "info_internet",
      "questionType": "multiple_choice",
      "question": "Welke website is het MEEST geschikt als bron voor een werkstuk over het klimaat?",
      "options": ["Een artikel van het KNMI (Koninklijk Nederlands Meteorologisch Instituut)", "Een persoonlijke blogpost van een weer-liefhebber", "Een Wikipedia-pagina zonder bronvermelding erbij", "Een commerciële reclame voor zonnepanelen"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Betrouwbare bronnen",
            "content": "Officiële instanties (zoals KNMI, Rijksoverheid, universiteiten) zijn betrouwbaarder dan persoonlijke blogs of commerciële websites. Ze hebben experts in dienst en controleren hun informatie.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "internet_bronkeuze",
      "variantIndex": 3,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.76,
      "pedagogy": {
        "dok": 2
      },
      "feedback": {
        "explanationText": "Het KNMI is een officieel wetenschappelijk instituut met experts. Hun informatie is gecontroleerd en betrouwbaar. Blogs, Wikipedia zonder bronnen en reclame zijn minder geschikt.",
        "solutionSteps": [
          "KNMI = officieel wetenschappelijk instituut",
          "Experts controleren de informatie",
          "Betrouwbaarder dan blogs, ongecontroleerde Wikipedia of reclame"
        ],
        "distractorExplanations": {
          "0": "Goed! Het KNMI is een officieel instituut met gecontroleerde informatie.",
          "1": "Een persoonlijke blog kan interessant zijn, maar is niet gecontroleerd door experts.",
          "2": "Wikipedia kan nuttig zijn, maar zonder bronvermelding kun je de informatie niet controleren.",
          "3": "Reclame wil iets verkopen en geeft daarom eenzijdige informatie."
        }
      }
    },
    {
      "id": "STU-INTERNET-004",
      "familyId": "STU-INTERNET",
      "module": "Studievaardig",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "informatie",
      "subSkill": "info_internet",
      "questionType": "multiple_choice",
      "question": "Je zoekt op 'jaguar' en krijgt resultaten over auto's, maar je wilt informatie over het dier. Wat doe je?",
      "options": ["Zoek op 'jaguar dier' of 'jaguar roofdier'", "Klik op alle resultaten tot je het dier vindt", "Zoek op een ander woord zoals 'tijger'", "Geef op en kies een ander onderwerp"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Zoekterm verfijnen",
            "content": "Als je zoekresultaten niet kloppen, voeg een extra woord toe dat verduidelijkt wat je bedoelt. 'Jaguar dier' of 'jaguar roofdier' filtert de autoresultaten weg.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "internet_verfijnen",
      "variantIndex": 4,
      "citoDifficulty": 0.25,
      "citoDiscrimination": 0.78,
      "pedagogy": {
        "dok": 2
      },
      "feedback": {
        "explanationText": "Door een extra woord toe te voegen ('dier' of 'roofdier') maak je je zoekopdracht specifieker. Google begrijpt dan dat je het dier bedoelt, niet het automerk.",
        "solutionSteps": [
          "Resultaten kloppen niet → verfijn je zoekterm",
          "Voeg een verduidelijkend woord toe",
          "'Jaguar dier' geeft resultaten over het roofdier"
        ],
        "distractorExplanations": {
          "0": "Goed! Een extra woord toevoegen maakt je zoekopdracht specifieker.",
          "1": "Alle resultaten doorklikken kost veel tijd en is niet efficiënt.",
          "2": "Een tijger is een ander dier. Je wilt informatie over de jaguar, niet over een tijger.",
          "3": "Opgeven is niet nodig — je hoeft alleen je zoekterm aan te passen."
        }
      }
    },
    {
      "id": "STU-INTERNET-005",
      "familyId": "STU-INTERNET",
      "module": "Studievaardig",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "informatie",
      "subSkill": "info_internet",
      "questionType": "ordering",
      "question": "Zet de stappen voor het zoeken op internet in de juiste volgorde.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "items": [
          "Bedenk wat je precies wilt weten",
          "Kies goede zoektermen",
          "Bekijk de zoekresultaten",
          "Check of de bron betrouwbaar is",
          "Gebruik de informatie in je werkstuk"
        ],
        "correctOrder": [0, 1, 2, 3, 4]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Stappenplan zoeken",
            "content": "1) Bedenk je vraag. 2) Kies zoektermen. 3) Bekijk resultaten. 4) Check betrouwbaarheid. 5) Gebruik de informatie. Altijd eerst nadenken, dan zoeken, dan controleren!",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "internet_stappenplan",
      "variantIndex": 5,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Eerst bedenk je wat je wilt weten, dan kies je zoektermen, bekijk je de resultaten, check je de betrouwbaarheid en gebruik je de informatie.",
        "solutionSteps": [
          "1. Bedenk wat je wilt weten",
          "2. Kies goede zoektermen",
          "3. Bekijk de zoekresultaten",
          "4. Check betrouwbaarheid",
          "5. Gebruik de informatie"
        ]
      }
    }
  ]
}